class ColorDotSelector extends HTMLElement {
  constructor() {
    super();

    // Ensure the container exists
    this.container = this.querySelector(".color-dots__container");
    this.body = document.querySelector("body");
    this.colorush = false;
    if (!this.container) {
      console.error("Error: Color dots container not found!");
      return;
    }

    this.init();
  }

  /**
   * Initialize event listeners
   */
  init() {
    
    this.container.addEventListener("change", (event) => {
      if (event.target.type === "radio" && event.target.name.includes('color-dot')) {
        // this.body.classList.add("loading");
        this.handleSelection(event.target);
      }
    });
  }

  /**
   * Handle the radio button selection
   * @param {HTMLElement} selectedRadio - Selected radio button element
   */
  async handleSelection(selectedRadio) {    
    const productId = selectedRadio.getAttribute("data-parent-id");
    const productCard = document.querySelector(`[data-product-id='${productId}']`);

    const productHandle = selectedRadio.getAttribute("data-product-id");
    const productTitle = selectedRadio.getAttribute("data-product-name");
    const productUrl = selectedRadio.getAttribute("data-product-url");

    const productImage1 = selectedRadio.getAttribute("data-product-image-1");
    const productImage2 = selectedRadio.getAttribute("data-product-image-2");

    const widths = [340, 480, 740];
    const primaryImageElement = productCard.querySelector('.default-image.theme-img,.single-image.theme-img,.product-block__image--primary img');
    const secondaryImageElement = productCard.querySelector('.hover-image.theme-img,.product-block__image--secondary img');
    
    productCard.querySelector('.product-title h1').textContent = productTitle;
    productCard.querySelector('.product-link').href = productUrl;

    if (primaryImageElement) {
      this.updateImageSrcSet(primaryImageElement, productImage1, widths);
    }

    if (secondaryImageElement) {
      this.updateImageSrcSet(secondaryImageElement, productImage2, widths);
    }

    document.dispatchEvent(new CustomEvent('collection:color-dot:change', {
      detail: {
        productHandle
      },
    }));
  }

  generateSrcSet(baseUrl, widths) {
    const imageUrlObject = baseUrl.includes('https') ? new URL(baseUrl) : new URL(`https:${baseUrl}`);    
    return widths
      .map(width => {
        imageUrlObject.searchParams.set('width', width);
        return `${imageUrlObject.href} ${width}w`;
      }).join(', ');
  }
  
  updateImageSrcSet(imgElement, newBaseUrl, widths) {
    if (!imgElement || !newBaseUrl || !widths || widths.length === 0) {
      console.error('Invalid parameters provided.');
      return;
    }    
    const srcSet = this.generateSrcSet(newBaseUrl, widths);
    imgElement.setAttribute('srcset', srcSet);
  }
  
  /**
   * Fetch product section HTML
   * @param {string} productHandle - Handle of the selected product
   * @returns {Promise<string>} - Section HTML
   */
  async fetchProductSection(productHandle) {
    const apiEndpoint = `/products/${productHandle}.json`;
    const response = await fetch(apiEndpoint);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    return response.json();
  }

  /**
   * Update the product section in the DOM
   * @param {string} html - HTML content of the product section
   * @param {string} productHandle - Product handle for the new URL
   */
  updateProductSection(product, productHandle) {

  }
  updateProductOptions () {

  }
}

// Define the custom element
customElements.define("color-dot-selector", ColorDotSelector);


// Filters scrolling
const scrollableList = document.querySelector('.sr-menu-parent');

let isDragging = false;
let startX, scrollLeft;

scrollableList.addEventListener('mousedown', (e) => {
  isDragging = true;
  startX = e.pageX - scrollableList.offsetLeft;
  scrollLeft = scrollableList.scrollLeft;
  scrollableList.style.cursor = 'grabbing';
});

scrollableList.addEventListener('mouseleave', () => {
  isDragging = false;
  scrollableList.style.cursor = 'grab'; 
});

scrollableList.addEventListener('mouseup', () => {
  isDragging = false;
  scrollableList.style.cursor = 'grab'; 
});

scrollableList.addEventListener('mousemove', (e) => {
  if (!isDragging) return;
  e.preventDefault();
  const x = e.pageX - scrollableList.offsetLeft;
  const walk = (x - startX) * 2; // Multiply for faster scroll
  scrollableList.scrollLeft = scrollLeft - walk;
});

// Touch support for mobile
scrollableList.addEventListener('touchstart', (e) => {
  isDragging = true;
  startX = e.touches[0].pageX - scrollableList.offsetLeft;
  scrollLeft = scrollableList.scrollLeft;
});

scrollableList.addEventListener('touchmove', (e) => {
  if (!isDragging) return;
  const x = e.touches[0].pageX - scrollableList.offsetLeft;
  const walk = (x - startX) * 2;
  scrollableList.scrollLeft = scrollLeft - walk;
});

scrollableList.addEventListener('touchend', () => {
  isDragging = false;
});

const stickyFilter = document.querySelector('.sticky-filter');

if (stickyFilter) {
  // Calculate the original offset position of the sticky filter
  const stickyOffsetTop = stickyFilter.offsetTop;

  window.addEventListener('scroll', () => {
    // Get the current scroll position
    const scrollPosition = window.scrollY + 100;
    // Check if the user has scrolled past the sticky filter's original position
    if (scrollPosition >= stickyOffsetTop) {
      // Add fixed position when scrolled down
      stickyFilter.style.position = 'fixed';
    } else {
      // Revert to its original position when scrolling back up
      stickyFilter.style.position = 'static';
      stickyFilter.style.top = ''; // Clear the top property
    }
  });
} else {
  console.error("Sticky filter not found!");
}



